/** Exact serialized snapshots are compared, never device clocks. null represents an absent or deleted value. */
export type SyncSnapshot = string | null;
export type ReconcileDecision = 'unchanged' | 'upload' | 'download' | 'conflict';

/** Undefined baseline means this device has not yet synchronized this record. */
export function reconcile(local: SyncSnapshot, remote: SyncSnapshot, baseline: SyncSnapshot | undefined): ReconcileDecision {
  if (local === remote) return 'unchanged';
  if (baseline === undefined) {
    if (remote === null) return 'upload';
    if (local === null) return 'download';
    return 'conflict';
  }
  if (local === baseline) return 'download';
  if (remote === baseline) return 'upload';
  return 'conflict';
}
